import { render, staticRenderFns } from "./procDefNode.vue?vue&type=template&id=aaa35ec4&scoped=true&"
import script from "./procDefNode.vue?vue&type=script&lang=js&"
export * from "./procDefNode.vue?vue&type=script&lang=js&"
import style0 from "./procDefNode.vue?vue&type=style&index=0&id=aaa35ec4&scoped=true&lang=less&"
import style1 from "./procDefNode.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa35ec4",
  null
  
)

export default component.exports